import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Angular = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
         <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Why Angualar</h1>
          <p>Learn through our all-inclusive AngularJS course syllabus with adequate practical experiences to develop the easy to manage web pages. Our trainers are skilled and have the industry experience to handle classes as per the student’s
            proficiency. We assist you for the assured placement after the successful course completion with valuable certification at Acrosys Technologies.</p>
          <p><b>Session 1: Introduction to HTML</b></p>
          <p>HTML Basics, Elements, Attributes, Styles Forms, Form Elements, Input Element Types Input Attributes, File Paths, Script tag HTML &amp;XHTML</p>
          <b>Session 2: Introduction to CSS</b>
          <p />
          <p>
            CSS Introduction, Syntax, Selectors, Styling Pseudo class, Pseudo Elements CSS Tables, CSS Box Models CSS Opacity, CSS Navigation Bar, Dropdowns </p>
          <b>Session 3: Introduction to JavaScript</b>
          <p> JavaScript Statements, Keywords, Functions JavaScript Programs, Operators, Functions Function Parameters, Function Return Types Data Types, Primitive Types </p>
          <b>Session 4: Working with Objects </b>
          <p>Object Oriented Programming, Object Creation Adding Methods of Objects JavaScript Loops &amp; Iteration Adding Properties of Objects JavaScript Conditional Statements Enumerating Properties, Callbacks, JSON</p>
          <b>Session 5: Angular JS Basics</b>
          <p> What is Angular JS? Why Angular JS? Why MVC matters MVC-The Angular JS way Features of Angular JS ,Model-View-Controller My First Angular JS app</p>
          <b>Session 6: Angular Expressions</b>
          <p> All about Angular Expressions How to use expressions, Angular vs JavaScript</p><b> Session 7: Filters </b>
          <p>Built-In Filters, Using Angular JS Filters Creating Custom Filters</p>
          <b>Session 8: Directives </b>
          <p>Introduction to Directives, Directive Lifecycle Binding controls to data, Matching directives Using Angular JS built-in directives Creating a custom directive</p>
          <b> Session 9: Controllers </b>
          <p>Role of a Controller, Controllers &amp; Modules Attaching Properties and functions to scope Nested Controllers, Using Filters in Controllers Controllers in External Files</p>
          <b> Session 10: Angular JS Modules</b>
          <p> Introduction to Angular JS Modules Bootstrapping Angular JS </p>
          <b> Session 11:</b>
          <p> Angular JS Forms Working with Angular Forms, Model Binding Forms Events, Updating Models with a Twist Form Controller, Validating Angular Forms $error object </p>
          <b>Session 12: </b>
          <p> What is scope, Scope Lifecycle Scope Inheritance, Scope &amp; Controllers Root scope, Scope Broadcasting Two-way data binding, Scope Inheritance Scope &amp; Directives, $apply and $watch Scope Events. </p>
          <b> Session 13: </b>
          <p> Dependency Injection &amp; Services What is Dependency Injection Creating Services, Factory, Service &amp; Provider Using Dependency Injection, What are services Using Angular JS built in services
            <b /></p><b> Session 14:</b>
          <p>Single Page Application (SPA) What is SPA, Pros and Cons of SPA Passing Parameters, Changing location Installing the ng Route module, Configure routes Resolving promises, Creating a Single Page Apps </p><b>Session 15:</b>
          <p>
            Angular JS Animation ng Animate Module, CSS Transforms CSS Transitions, Applying Animations
          </p><p /> <b>Session 16:</b>
          <p> Introduction to Node JS Introduction to Node JS Advantages of Node JS What is Node JS, Node.js Process Model Traditional Web Server Model</p><b>Session 17:
          </b>
          <p> Setup Development Environment Install Node.js on Windows Working in REPL, Node JS Console </p><b>Session 18:</b>
          <p> Node JS Modules Functions, Buffer, Module Modules Types Core Modules, Local Modules Modules Exports</p><b> Session
            19:
          </b>
          <p> Node Package Manager What is NPM, Installing Packages Locally Installing package globally Adding dependency in package json Updating packages</p><b> Session 20: </b>
          <p>Creating Web Server Creating Web Server Sending Requests Handling http requests
          </p><b>Session 21: </b>
          <p>File System read File, Writing a File Opening a file, Deleting a file Writing a file asynchronously Other IO Operations </p><b>Session 22: </b>Debugging Node JS Application Core Node JS Debugger <p /><b>Session 23:
          </b>
          <p> Events Event Emitter class Inheriting Events Returning event emitter </p><b>Session 24:</b>
          <p>Express JS Configuring Routes Working with Express </p><b>Session 25:</b>
          <p> Serving Static Resources Serving Static Files Working with Middle Ware
          </p>
          <b>Session 26: </b>
          <p>Database Connectivity Connecting String, Configuring Updating Records Working with Select Command Deleting Records </p><b>Session 27: </b>
          <p>Project Development Project Development using Node JS</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
          <Comment/>
        {/* Comment List End */}
        {/* Comment Form Start */}

        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
       <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Angular